var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStarIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1969 0.773351C11.9761 0.300748 11.5095 0 10.997 0C10.4846 0 10.0221 0.300748 9.79714 0.773351L7.11826 6.45748L1.13556 7.36832C0.635617 7.44565 0.218995 7.80655 0.064845 8.30063C-0.0893052 8.79472 0.0356813 9.34036 0.393976 9.70555L4.73518 14.1351L3.71029 20.395C3.62696 20.9106 3.83527 21.4347 4.24773 21.7398C4.66019 22.0448 5.20596 22.0835 5.65591 21.8386L11.0012 18.8955L16.3464 21.8386C16.7964 22.0835 17.3422 22.0491 17.7546 21.7398C18.1671 21.4304 18.3754 20.9106 18.2921 20.395L17.263 14.1351L21.6042 9.70555C21.9625 9.34036 22.0917 8.79472 21.9333 8.30063C21.775 7.80655 21.3626 7.44565 20.8626 7.36832L14.8758 6.45748L12.1969 0.773351Z",
    fill: "url(#paint0_linear_607_2314)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_607_2314",
    x1: 0,
    y1: 0,
    x2: 23,
    y2: 22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9242FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.183008,
    stopColor: "#797EF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.546875,
    stopColor: "#69A3F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78125,
    stopColor: "#5BBEDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#43EAB2"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarIcon);
export default __webpack_public_path__ + "static/media/star-icon.f03ca3751f5daa306cbbbc5999350acc.svg";
export { ForwardRef as ReactComponent };